"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  spareStockingManage: {
    common: {
      operationRequirement: 'Operation Requirement',
      spiManagement: 'Spare Parts Inspect',
      approvalHistory: 'Approval History'
    },
    btn: {
      cancel: 'Invalid',
      refreshStock: 'Refresh Stock'
    },
    placehoder: {
      selectDate: 'Select Date'
    },
    keyWordFilter: {
      ir: 'Can query spare part name, spare part number, drawing number, equipment name, storage location information, po number',
      iv: 'Can query inventory number, inventory person',
      po: 'Can query processing order number, port'
    },
    inventoryRecordManage: {
      refreshStockSuccess: 'refresh stock success',
      transferor: 'Transferor',
      device: 'Device',
      partsType: 'Parts Type',
      stockQuantity: 'Physical Stock Qty.',
      partsModel: 'Parts Model',
      proposedPriceCurrency: 'Propose Price Currency',
      monitorFlag: 'Is Monitor',
      blindFlag: 'Is Blind',
      partsRemark: 'Parts Remark',
      personInCharge: 'Person in Charge',
      isLtMinStock: 'IsLtMinStock',
      isGtMaxStock: 'IsGtMaxStock',
      locationInfo: 'Location Info',
      nowStockQyt: 'Now Stock Qty',
      stockQtyValue: 'Stock Qty Value',
      changeStock: 'Change Stock',
      changeStockOptTips: 'Move library operation manual',
      mtrCatoryEn: 'Spare Name En',
      drawItem: 'Draw No.',
      drawItemIng: 'Item No.',
      applySpec: 'Spare Spec',
      eqpShop: 'Equipment Manufacturer',
      outStockNum: 'Physical Stock Qty.',
      preQty: 'Pre Qty',
      timeQty: 'Period Variation',
      aftQty: 'Aft Qty',
      iRManage: 'Inventory Management',
      inRItem: 'In RItem',
      hSPROHistory: 'HSPRO History',
      sBLoction: 'Loction',
      shipName: 'Vessel Name',
      dept: 'Dept',
      applyType: 'Device Name',
      mtrCatory: 'Spare Name Cn',
      mtrName: 'Spare Part Id',
      mtrEnName: 'Material Name En',
      unit: 'Unit',
      stockNum: 'Stock',
      minStock: 'Min Stock',
      maxStock: 'Max Stock',
      option: 'Operation',
      outStock: 'In Out Stock',
      outStockMsg: 'In Out Stock Info',
      stockTip: 'Spare parts cannot be shipped out manually, they can only be consumed through inventory or work orders',
      stockMsg: 'Location Info',
      stockingNum: 'Physical Stock Qty.',
      remark: 'Remark',
      outStockCatory: 'In Out Stock Type',
      number: 'Qty',
      date: 'Date',
      checkedNum: 'Replaced Qty',
      price: 'Price',
      putLoc: 'Location',
      hasHarm: 'Has Harm:',
      outStockSeq: 'Out Stock Seq',
      inStock: 'In Stock',
      inStockMsg: 'In Stock Msg',
      inStockCatory: 'In Stock Type',
      outInStockDaily: 'In Out Stock Record',
      orderOrtransferNo: 'Order or Transfer No',
      currentLocation: 'Current Location Qty',
      changeNum: 'Change Qty',
      currency: 'Currency',
      stockRate: 'Rate',
      material: 'Material',
      inOutDate: 'In Out Date',
      inOrOut: 'In or Out',
      inOutStockCatory: 'In Out Stock Type',
      inOutFlag: 'In Out Flag',
      company: 'Company',
      optiontor: 'Operator',
      duties: 'Rank',
      beginDate: 'Begin Date',
      endDate: 'End Date',
      columon: {
        shipCode: 'Ship Code',
        locCode: 'Location Code',
        locName: 'Location Name',
        locNameEn: 'Location Name En'
      },
      rules: {
        typeRequired: 'Type Required',
        numRequired: 'Num Required',
        dateRequired: 'Date Required',
        deptRequired: 'Dept Required',
        loctionRequired: 'Loction Required'
      }
    },
    inventoryVerification: {
      inventoryManual: 'Inventory operation manual',
      keyWordFilter: 'You can inquire the name and number of spare parts',
      inventoryChecking: 'Inventory Check',
      inventoryInfo: 'Inventory Info',
      icAdd: 'Stock Inventory Add',
      icEdit: 'Stock Inventory Edit',
      takingStock: 'Inventorying',
      approvaling: 'Approvaling',
      approvalRej: 'Approval Reject',
      approved: 'Approved',
      cancel: 'Invalid',
      allApproval: 'All',
      shipName: 'Vessel Name',
      department: 'Department',
      inventoryNo: 'Inventory No',
      inventoryMan: 'Inventoryer',
      inventoryTime: 'Inventory Time',
      status: 'Status',
      remark: 'Remark',
      inventoryStartTime: 'Inventory Start Time',
      inventorySubmitTime: 'Inventory Submit Time',
      sequenceCode: 'Sequence Code',
      toEquip: 'Subordinate Equipment',
      spName: 'Spare Name',
      spNo: 'Spare Id',
      drawingNo: 'Material Code',
      inDrawingNo: 'Spec',
      unit: 'Unit',
      currentLocation: 'Current Location',
      lastStock: 'Last Stock Qty',
      quantityReceived: 'Quantity Received',
      consumptionQuantity: 'Consumption Quantity',
      bookStock: 'Book Stock',
      inventoryRecordTime: 'Book Stock Statistics Time',
      physicalStock: 'Physical Stock Qty',
      physicalStockTip: 'Please fill in the physical inventory according to the inventory at the time of book inventory statistics',
      systemStockQtySum: 'Total book stock',
      checkStockQtySum: 'Total physical stock',
      difference: 'Difference',
      gainOrloss: 'Gain or loss',
      gainOrlossNumber: 'Gain or Loss Number',
      gainOrlossMoney: 'Gain or Loss Money',
      company: 'Company',
      firstSubmitQty: 'First Submit Qty',
      onlyShowNoEq: 'Only Show No Eq',
      onlyShowNoCheckItem: 'Show only uncounted items',
      checkDeleteTip: 'After the invalidation, the inventory record generated during this inventory will be restored to the time before the inventory, whether to confirm the invalidation of the record',
      onlyShowControledItem: 'Show only controlled items',
      inventoryProfitReason: 'Reasons for Inventory Profit and Loss',
      inventoryProfitExplain: 'Reasons for Inventory Profit and Loss',
      monitorTip1: 'The reason for the profit and loss of the controlled project must be indicated',
      monitorTip2: 'Reasons for abnormal inventory gains and losses of controlled projects need to be indicated',
      equipInfo: 'Device Info',
      inventoryVerificationTips: 'After the inventory order is submitted, the inventory will be adjusted automatically, no need to manually adjust the inventory.',
      prioritizeConsumption: 'Please prioritize consumption of such items',
      spareInfo: 'Spare Info',
      inventoryFileList: 'Attachment Info',
      inventoryHistoryList: 'Approval History',
      equipName: 'Device Name',
      equipCode: 'Device No',
      equipEsc: 'Device Type',
      equipSeq: 'Device Serial',
      manufacturer: 'Manufacturer',
      reCheck: 'Inventory review',
      reCheck1: 'The gap between the following inventory items and the book inventory is too large, please check whether the physical inventory is accurate. If it is correct, please click the OK button to submit; if it is wrong, please click the Cancel button to return and reject.',
      reCheck2: 'The gap between the following inventory items and the book inventory is too large, please check whether the physical inventory is accurate. If it is correct, please click the OK button to submit; if it is wrong, you can edit it in this pop-up window and click the OK button to submit.'
    },
    prosOrderMainManage: {
      prosOMag: 'Used Store Control',
      spName: 'Vessel Name',
      dept: 'Dept',
      opNo: 'Deal No',
      opShop: 'Processors',
      opTime: 'Deal Time',
      crgo: 'Port',
      status: 'Status',
      remark: 'Remark',
      option: 'Operation',
      opMsg: 'Deal Info',
      materialMsg: 'Material Info',
      chooseDM: 'Choose Deal Material',
      useType: 'Use Status',
      hasHarm: 'Has Harm',
      currentLocation: 'Current Location',
      applyType: 'Device Name',
      mtrCatr: 'Device Model',
      matrShop: 'Device Serial No.',
      mtrName: 'Material Supplier',
      mtrNo: 'Spare Name',
      specNo: 'Spare ID',
      unit: 'Unit',
      opCatr: 'Deal Type',
      opNum: 'Deal Qty',
      qty: 'Qty',
      badNum: 'Scrap Qty',
      backNum: 'Back Qyt',
      allMtr: 'All',
      mtring: 'In Use Material',
      badMtr: 'Scrap Material',
      noSubmit: 'No Submit',
      submited: 'Submited',
      drawItem: 'Draw No.',
      drawItemIng: 'Item No.',
      parts: 'Spare',
      rules: {
        spNameReq: 'Sp Name Req',
        deptReq: 'Dept Req',
        opNoReq: 'Op No Req',
        opTimeReq: 'Op Time Req',
        opShopReq: 'Op Shop Req'
      }
    }
  }
};